import React, {useEffect} from 'react';
import AddEditRichText from "../../../content/components/rich-text-editor/add-edit-rich-text";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import {markAsPublishedBlogPost} from "../../../content/utils/blog-content-util";
import RichTextEditor from "../../../content/components/rich-text-editor/rich-text-editor";
import RenderFeaturedImage from "./render-featured-image";
import {prepareCreatedArticleDetail, prepareShopifyBlogArticle} from "../../utils/shopify-blog-util";
import {initPublishArticleToShopifyBlog} from "../../../common/services/cloud-function-service";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import {getSingleDesignById} from "../../../design/services/design-data-service";
import {getSingleDesignInfo, updateSingleDesignInfo} from "../../services/design-info-data.service";

const ShopifyBlogArticle = ({
                                blogPost,
                                setBlogPost,
                                blogPostContent,
                                featuredImage,
                                setSaveInProgress
                            }) => {
    const [imageBase64, setImageBase64] = React.useState(null);

    const handleMarkAsPublishedBlogPost = async () => {
        setSaveInProgress(true);
        const article = prepareShopifyBlogArticle(blogPost, blogPostContent, imageBase64);
        const response = await initPublishArticleToShopifyBlog(article);

        const createdArticle = response?.article;
        const existingBlogPost = {...blogPost};
        existingBlogPost.shopifyArticle = prepareCreatedArticleDetail(createdArticle);

        await markAsPublishedBlogPost(existingBlogPost);
        await handleUpdateBlogPost(existingBlogPost);

        setBlogPost(existingBlogPost);
        setSaveInProgress(false);
    }

    const handleUpdateBlogPost = async (existingBlogPost) => {
        const designInfo = await getSingleDesignInfo(existingBlogPost?.designId);
        designInfo.blogPost.status = existingBlogPost?.status || 'Published';
        await updateSingleDesignInfo(designInfo);
    }

    return (
        <>

            <div className="w-full flex justify-start items-center h-fit mt-4">

                <h3 className={'text-xl ml-2 font-bold text-purple-500'}>{blogPost?.title}</h3>

                {blogPost?.status &&
                    <div>
                        <div className="button-purple-outline px-2 ml-2 text-lg font-semibold">
                            {blogPost?.status}
                        </div>
                    </div>
                }
                <div className={'ml-2'}>
                    <CopyDataToClipboard
                        sizeClass={'px-2 py-2'}
                        value={blogPost?.title}/>
                </div>

                <div>
                    <CopyDataToClipboard
                        sizeClass={'px-2 py-2'}
                        value={blogPostContent?.htmlContent}
                        label={'Copy Post'}/>
                </div>

                <div>
                    <button
                        className="button-green px-3 py-2 m-1"
                        onClick={() => handleMarkAsPublishedBlogPost()}>
                        Publish Blog Post
                    </button>
                </div>

            </div>

            <div className="w-full flex justify-between h-fit mt-4">
                <div
                    className={`mx-2 w-fit p-4 border border-gray-500 rounded-lg bg-white design-product-blog-post-content-container overflow-y-scroll`}>
                    <div>
                        <ReactMarkdown
                            children={blogPostContent?.htmlContent}
                            rehypePlugins={[rehypeRaw]}
                            skipHtml={false}
                            className="mt-2 content-container"/>
                    </div>

                    {/*<RichTextEditor
                        readOnly={true}
                        existingContent={blogPostContent?.htmlContent}
                        setContentLines={null}/>*/}
                </div>

                <div
                    className="mx-2 w-fit p-4 border border-gray-500 rounded-lg bg-sky-50 design-product-blog-post-content-container overflow-y-scroll">
                    {blogPostContent?.metaLines?.map((metaLine, metaLineIndex) => (
                        <div key={`metaLine-${metaLineIndex}`}>
                            <div
                                className={`w-full mb-3 p-3 border border-gray-400 bg-white shadow-lg rounded-xl`}>

                                <div className={'flex items-center justify-between'}>
                                    <div className={`w-full`}>
                                        {metaLine?.isMeta &&
                                            <div
                                                className={`flex justify-start text-gray-900 font-bold text-sky-500`}>
                                                <div className={''}>{metaLine.metaLabel}</div>
                                            </div>
                                        }
                                        <div
                                            className={`flex justify-start text-gray-900 ${metaLine.isSection ? 'font-bold text-pink-500' : ''}`}>
                                            <div className={''}>{metaLine.text}</div>
                                        </div>
                                    </div>

                                    <div className={'flex justify-between ml-2'}>
                                        <div>
                                            <CopyDataToClipboard
                                                sizeClass={'px-2 py-2'}
                                                value={metaLine?.text}/>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}

                    <div className="flex justify-center m-4">
                        <RenderFeaturedImage
                            imageContainerClass={'featured-image-stage-container-preview'}
                            selectedImages={featuredImage.images}
                            setImageBase64={setImageBase64}
                            setSelectedImages={() => {
                            }}
                            settings={featuredImage.settings}/>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ShopifyBlogArticle
